import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
    ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    clientname: {
      validations: []
    },
    description: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please select an option' },
      ]
    },
    plannedGuestCount: {
      validations: []
    },
    accountextra6: {
      validations: []
    },
    website: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'EVENT INFORMATION',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Organization:',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'What type of event(s) are you planning?:*',
            mapping: 'description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Preferred Event Date(s):',
            mapping: 'EventDate'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Attendees:',
            mapping: 'plannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'How did you find out about us?:*',
        options: [
          { label: 'Online Search', value: 'Online Search' },
          { label: 'Word of Mouth', value: 'Word of Mouth' },
          { label: 'Attended Venue', value: 'Attended Venue' },
          { label: 'Blog or Publications', value: 'Blog or Publications' },
          { label: 'The Knot/Wedding Wire', value: 'The Knot/Wedding Wire' },
          { label: 'Facebook', value: 'Facebook' },
          { label: 'Instagram', value: 'Instagram' },
          { label: 'LinkedIn', value: 'LinkedIn' },
          { label: 'Tradeshow/Networking Event', value: 'Tradeshow/Networking Event' },
          { label: 'Twitter/X', value: 'Twitter/X' },
          { label: 'Pinterest', value: 'Pinterest' },
          { label: 'Vendor Referral', value: 'Vendor Referral' },
          { label: 'Other', value: 'Other' },
        ],
        mapping: 'reference'
      },
      {
        type: 'text',
        size: 'Medium',
        label: 'If you chose "Other" share how you heard about our venue:',
        mapping: 'accountextra6'
      }
    ]
  },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'We would love to hear more! Please provide additional questions or comments below:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Sterling Spaces Corporate/Non-Profit Contact Form',
    formId: '2060',
    clientKey: '69B48C98-CC92-4059-AEE2-3F3B9B277499',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'We appreciate your inquiry! Someone from our team will be following up with you within the next 24 business hours. Our venue offers turnkey options for any event. From venue rental to event coordination, our team of experts will work with you to create a memorable event that exceeds your expectations. We look forward to the opportunity to work with you to make your event a success! If you need immediate assistance, please reach out to our team at (336) 397-2031 during our regular business hours.',
    redirectUrl: 'https://visitsterlingspaces.com/thank-you/',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
